// ============================================================================
// VYVA Onboarding Portal - Page Loader Component
// ============================================================================

import { Loader2 } from 'lucide-react';

interface PageLoaderProps {
  message?: string;
}

export function PageLoader({ message = 'Loading...' }: PageLoaderProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] w-full">
      <Loader2 className="h-10 w-10 animate-spin text-[#7A2CC7]" />
      <p className="mt-4 text-muted-foreground animate-pulse">{message}</p>
    </div>
  );
}

export default PageLoader;

